import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/ZepQuizColorPrimary.tsx
const ZepQuizColorPrimaryIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M21.32 10.025c.4-1.67.267-3.23-.512-4.456-1.025-1.648-3.008-2.384-5.348-2.272C13.7 1.447 11.561.6 9.534 1.18c-1.649.49-2.963 1.872-3.788 3.765-1.982.736-3.453 2.05-4.01 3.833-.468 1.492-.223 3.074.58 4.567-.647 1.938-.602 3.787.289 5.213 1.136 1.805 3.364 2.518 5.993 2.228 1.76 1.827 3.877 2.652 5.882 2.05 1.649-.49 2.963-1.871 3.788-3.765 1.982-.736 3.453-2.05 3.988-3.81.534-1.716.178-3.565-.936-5.236Z",
		fill: "#6758FF"
	}), /* @__PURE__ */ jsx("path", {
		d: "M14.175 17.75c-.39 0-.744-.21-1.078-.642l-.364-.474h-.708c-2.578 0-4.309-1.825-4.309-4.541s1.731-4.54 4.309-4.54c2.578 0 4.295 1.824 4.295 4.54 0 1.312-.414 2.46-1.171 3.27l.08.09c.298.307.443.637.419.976-.025.352-.225.677-.6.969-.292.234-.586.352-.87.352h-.003Zm-2.166-7.934c-1.207 0-1.958.878-1.958 2.293 0 1.414.769 2.366 1.958 2.366 1.19 0 1.974-.952 1.974-2.366 0-1.415-.775-2.293-1.974-2.293Z",
		fill: "#fff"
	})]
}));
export { ZepQuizColorPrimaryIcon };
